<script context="module">
  import { user } from "./userStore.js";
  let ref;
  let fromContext;
  let currentTask;
  //   export let author;

  // export {sendMessage};
  export function sendMessage(msg, dontIncreaseUnreadFromStudent) {
    let message = {
      text: msg,
      timestamp: Date.now(),
      //   author: author,
      from: fromContext,
      teacher: fromContext == "teacher" ? user.getOnAuthName() : ""
    };
    ref.push(message);
    if (fromContext == "teacher") user.increaseUnreadFromTeacher(currentTask);
    if (fromContext == "student" && !dontIncreaseUnreadFromStudent) user.increaseUnreadFromStudent(currentTask);
  }
</script>

<script>
  import marked from 'marked';
  import { beforeUpdate, afterUpdate, onMount, onDestroy } from "svelte";

  export let userId;
  export let task;
  export let from;
  let messages = [];
  let currentMsg = "";

  fromContext = from;
  currentTask = task;

  onMount(() => {
    ref = firebase.database().ref(
      // "edulearn/users/info/hash111/quests/-M7Jb_KFEG13_25pVeQu/tasks/-M7KuuORNvDzTP3TJItg/hw/"
      // "edulearn/users/info/hash111/quests/-M7Jb_KFEG13_25pVeQu/tasks/" + id + "/hw/"
      "edulearn/tasks/chatbyuserbytask/" + userId + "/" + task.id + "/"
    );
    ref.on("child_added", function(snap) {
      let msgKey = snap.key;
      let msg = snap.val();
      msg["id"] = msgKey;
      messages = [...messages, msg];
    });
  });

  onDestroy(() => {
    ref.off();
  });

const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
renderer.link = (href, title, text) => {
    const html = linkRenderer.call(renderer, href, title, text);
    return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
};
marked.setOptions({
  gfm: true,
  breaks: false
});

</script>

<style>
label {
    width: 100%;
}

input {
    width: 100%;
}

/* h3 {
    margin: 0;
    text-transform: uppercase;
    font-weight: 100;
    color: #ccc;
} */

.chat {
    text-align: left;
    color: #555;
    padding: 20px;
}

  .chat button {
    /* display: inline-block;
    border: 0;
    padding: 10px;
    text-transform: uppercase;
    border-radius: 5px; */
    /* background-color: #f0ad4e; */
    /* color: #fff; */

    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>
<!-- <h3>Чат с преподавателем</h3> -->
<div class="chat">
    {#each messages as message (message.id)}
      <!-- {message.from}: {@html marked(message.text, { renderer })} -->
      {@html marked((message.from == "teacher" ? message.teacher + ": " : "") + message.text, { renderer })} 
    {/each}
    <br />
    <label>          
    <input class="hw" bind:value={currentMsg} placeholder="" on:click|stopPropagation 
      on:keydown="{(event)=>{if (event.key === "Enter") {currentMsg && sendMessage(currentMsg); currentMsg = ""}}}"/>
    <button on:click="{()=>{currentMsg && sendMessage(currentMsg); currentMsg = ""}}">Отправить</button>
    </label>
</div>
<!-- https://вставьте сюда ссылку на выполненное задание -->
